import { useLayoutEffect, useState } from 'react';

/**
 * Largura (px, sem padding) de um elemento, atualizada a cada redimensionamento
 * — abrir/fechar as laterais muda a largura sem a janela mudar, por isso
 * ResizeObserver e não `resize` da janela. Devolve um ref callback (funciona
 * com elemento que monta depois) e a largura; 0 = ainda não medida.
 */
export function useElementWidth<T extends HTMLElement>(): [(el: T | null) => void, number] {
  const [el, setEl] = useState<T | null>(null);
  const [width, setWidth] = useState(0);
  useLayoutEffect(() => {
    if (!el || typeof ResizeObserver === 'undefined') return;
    setWidth(el.clientWidth);
    const ro = new ResizeObserver(([entry]) => setWidth(Math.round(entry.contentRect.width)));
    ro.observe(el);
    return () => ro.disconnect();
  }, [el]);
  return [setEl, width];
}
